import * as Sentry from '@sentry/react'
import { CrispSegmentsEnum } from '../types/crisp'

type CrispSessionData = {
  [key: string]: string | number | boolean
}

export const setCrispSessionInfo = (segments: CrispSegmentsEnum[], sessionData: CrispSessionData) => {
  try {
    if (!window.$crisp) {
      return
    }

    window.$crisp.push(['set', 'session:segments', [segments, true]])
    setCrispSessionData(sessionData)
  } catch (err) {
    // Swallow errors
    Sentry.captureException(err)
  }
}

export const setCrispSessionData = (sessionData: CrispSessionData) => {
  if (!window.$crisp) {
    return
  }
  window.$crisp.push(['set', 'session:data', [Object.entries(sessionData)]])
}

export const openChat = (externalLink = false): void => {
  if (window && window.$crisp) {
    window.$crisp.push(['do', 'chat:open'])
    return
  }
  if (externalLink) {
    window.open('https://vacationtracker.io/helpdesk/', '_blank')?.focus()
  }
}

export const hideChat = (): void => {
  window.$crisp && window.$crisp.push(['do', 'chat:hide'])
}

export const hideAvailabilityTooltip = (): void => {
  window.$crisp && window.$crisp.push(['config', 'availability:tooltip', [false]])
}

export const sendChatMessage = (message: string): void => {
  window.$crisp && window.$crisp.push(['do', 'message:send', ['text', message]])
}